import LocalDB from "./LocalDB";
import { getHttpClient } from "./modules/http/http-client";

declare function GetTreeScroller(tree: DevExpress.ui.dxTreeView): DevExpress.ui.dxScrollable;

interface External {
    ConsoleLog: Function;
}

class GetFileResponse {
    Blob: string;
}

class ascommon {
    static isCore: boolean;
    static isPrint: boolean;
    static AllowFileLogging: boolean;
    static EncryptLogs: boolean;
    static IsDebugMode: boolean;

    // Sets up session storage with a valid auth token.
    static async initHttpClient() {
        await getHttpClient();
    }

    static ajax(url: string, params: object, successCallback: Function, errorCallback: Function = null, method: string = "POST", async: boolean = true, headers: object = {}) {
        $.extend(headers, {'X-AS-Session-ID': self.sessionID});
        let ajax: any = {
            url: url,
            type: method,
            data: url.startsWith('/api') ? JSON.stringify(params) : params,
            cache: false,
            async: async,
            headers: headers,
            contentType: url.startsWith('/api') ? 'application/json' : undefined,
            dataType: url.startsWith('/api') ? 'json' : undefined,
            success(result) {
                if (successCallback)
                    successCallback(result);
            },
            error(result) {
                if (errorCallback) {
                    errorCallback(result);
                }

                console.log("AJAX ERROR: " + JSON.stringify(result));
            },
            complete(result) {
                if (self && self.hideBusyIndicator) self.hideBusyIndicator();
            }
        }
        if (ascommon.isPrint) {
            ajax.processData = false;
            ajax.contentType = false;
            ascommon.isPrint = false;
        }
        $.ajax(ajax);
    }

    static async get<RequestType>(
        url: string,
        params: object,
        successCallback: Function = null,
        errorCallback: Function = null,
        finallyCallback: Function = null
    ) {
        const client = await getHttpClient();
        await client.get<RequestType>(
            url, params)
            .then(function (response) {
                if (successCallback) {
                    successCallback(response);
                }
            })
            .catch(function (error) {
                if (errorCallback) {
                    let override = errorCallback(error);
                    // if you want complete control over error handling return a true value from your error callback
                    // but if you just have some extra steps you want to layer on top of the default error actions
                    // forgo a specified return value
                    if (override === true) {
                        return;
                    }
                }

                // default error handling
                ascommon.log(`API error: ${error.code}\nMessage: ${error.message}`);
            })
            .finally(function (response) {
                if (finallyCallback) {
                    let override = finallyCallback(response);

                    if (override === true) {
                        return;
                    }
                }

                // default final handling
                if (self && self.hideBusyIndicator) {
                    self.hideBusyIndicator();
                }
            });
    }

    /*
    Make an api post request to the back-end.
    @url: the endpoint to hit
    @data: information payload to send
    @successCallback: actions to take after a successful response is returned
    @errorCallback: actions to take after a failed response is returned
    @finallyCallback: actions to take after a response is returned regardless of type
    @config: custom configuration for the request. Eg: custom headers
        See axios documentation on all available options. https://axios-http.com/docs/req_config
    */
    static async post<RequestType>(
        url: string,
        data: object,
        successCallback: Function = null,
        errorCallback: Function = null,
        finallyCallback: Function = null,
        config: object = null
    ) {
        const client = await getHttpClient();
        await client.post<RequestType>(
            url, data, config)
            .then(function (response) {
                if (successCallback) {
                    successCallback(response);
                }
            })
            .catch(function (error) {
                if (errorCallback) {
                    let override = errorCallback(error);
                    // if you want complete control over error handling return a true value from your error callback
                    // but if you just have some extra steps you want to layer on top of the default error actions
                    // forgo a specified return value
                    if (override === true) {
                        return;
                    }
                }

                // default error handling
                ascommon.log(`API error: ${error.code}\nMessage: ${error.message}`);
            })
            .finally(function (response) {
                if (finallyCallback) {
                    let override = finallyCallback(response);

                    if (override === true) {
                        return;
                    }
                }

                // default final handling
                if (self && self.hideBusyIndicator) {
                    self.hideBusyIndicator();
                }
            });
    }

    static async GetFile(type: string, fileName: string) {
        ascommon.get<GetFileResponse>(
            `/admin-tools/get-file/${type}/${fileName}/`,
            { responseType: "blob" },
            (response) => {
                const a = document.createElement("a");
                document.body.appendChild(a);
                a.style.display = "none";

                const blob = new Blob([response.data], { type: "application/octet-stream" });
                const url = self.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();

                // Clean up
                self.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            });
    }

    static Clone(originalObject, circular) {
        // http://blog.soulserv.net/understanding-object-cloning-in-javascript-part-ii/
        // First create an empty object with
        // same prototype of our original source

        let propertyIndex,
            descriptor,
            keys,
            current,
            nextSource,
            indexOf,
            copies = [{
                source: originalObject,
                target: Object.create(Object.getPrototypeOf(originalObject))
            }],
            cloneObject = copies[0].target,
            sourceReferences = [originalObject],
            targetReferences = [cloneObject];

        // First in, first out
        while (current = copies.shift()) {
            keys = Object.getOwnPropertyNames(current.source);

            for (propertyIndex = 0; propertyIndex < keys.length; propertyIndex++) {
                // Save the source's descriptor
                descriptor = Object.getOwnPropertyDescriptor(current.source, keys[propertyIndex]);

                if (!descriptor.value || typeof descriptor.value !== 'object') {
                    Object.defineProperty(current.target, keys[propertyIndex], descriptor);
                    continue;
                }

                nextSource = descriptor.value;
                descriptor.value = Array.isArray(nextSource) ?
                    [] :
                    Object.create(Object.getPrototypeOf(nextSource));

                if (circular) {
                    indexOf = sourceReferences.indexOf(nextSource);

                    if (indexOf !== -1) {
                        // The source is already referenced, just assign reference
                        descriptor.value = targetReferences[indexOf];
                        Object.defineProperty(current.target, keys[propertyIndex], descriptor);
                        continue;
                    }

                    sourceReferences.push(nextSource);
                    targetReferences.push(descriptor.value);
                }

                Object.defineProperty(current.target, keys[propertyIndex], descriptor);

                copies.push({ source: nextSource, target: descriptor.value });
            }
        }
        return cloneObject;
    }

    static DALExcecute(dalMethod: string, inpParams: any, callBack: Function) {
        ascommon.ajax("/Worklist/DALExcecute",
            {
                dalMethod: dalMethod,
                inpParams: inpParams
            },
            callBack);
    }

    static log(msg: string, type: LogType = LogType.Information): void {
        let dt: string = self.moment
            ? self.moment().format('DD-HH:mm:ss.SSS')
            : "";

        let stackTrace: string = "";
        if (ascommon.IsDebugMode || type === LogType.Error) {
            stackTrace = Error().stack.substring(7); // trim 'Error\n'
            stackTrace = stackTrace.substring(stackTrace.indexOf("\n")); // remove the ascommon.log stack frame as its redundant
        }

        if (self.boundLogger)
            //console log for chromium launcher
            self.boundLogger.sendConsoleCommand(`${dt}> ${msg}${stackTrace}`);
        else {
            //console log for browser
            if (ascommon.IsDebugMode) {
                // using groupCollapsed here so you can easily see the messages then expand to get the stack trace
                console.groupCollapsed(msg);
                console.trace();
                console.groupEnd();
            }
            else {
                switch (type) {
                    case LogType.Information:
                        console.log(`${dt}> ${msg}`);
                        break;
                    case LogType.Warn:
                        console.warn(`${dt}> ${msg}`);
                        break;
                    case LogType.Error:
                        console.error(`${dt}> ${msg}`);
                        break;
                }
            }
        }

        if (typeof LocalDB !== 'undefined' && ascommon.AllowFileLogging) {
            LocalDB.MessagePut(dt, ascommon.EncryptLogs
                ? EncrDecrService.Encript(`${msg}${stackTrace}`)
                : `${msg}${stackTrace}`);
        }

        DebugConsole.appendDebugLog(msg);
    }

    static getKeyByValue(object, value) {
        for (var prop in object) {
            if (object.hasOwnProperty(prop)) {
                if (object[prop] === value)
                    return prop;
            }
        }
    }
}

class DebugConsole {
    private static debugConsoleElem: HTMLElement;
    private static filterElem: HTMLInputElement;

    public static initialize() {
        removeEventListener("keydown", DebugConsole.handleHotKey);
        addEventListener("keydown", DebugConsole.handleHotKey);

        if (sessionStorage.getItem('debugConsoleShown') === 'true') {
            DebugConsole.toggleDebugConsole();
        }
    }

    public static handleHotKey(e: KeyboardEvent) {
        if (e.altKey && e.key === "c") {
            DebugConsole.toggleDebugConsole();
        }
    }

    public static toggleDebugConsole(){
        if (!DebugConsole.debugConsoleElem) {
            document.querySelector("#layout-main-div").insertAdjacentHTML("beforeend", `
                <div id="debugConsole" style="display: none; position: absolute; bottom: 0px; overflow: auto; width: 100vw; height: 200px; z-index: 15000; border: salmon solid 2px; background-color: #000000CC">
                    <span style="position: fixed; right: 0; height: 30px; color: red">
                        <input id="debugConsoleFilter" type="text" style="height: 30px;" onchange="DebugConsole.filterDebugLog()"/>
                        <button title="clear all" style="width: 30px; height: 30px;" onclick="DebugConsole.clearDebugLog()">\\_/</button>
                        <button title="close (alt+c)" style="margin-right: 20px; width: 30px; height: 30px;" onclick="DebugConsole.toggleDebugConsole()">X</button>
                    </span>
                </div>`);

            DebugConsole.debugConsoleElem = document.querySelector("#debugConsole");
            DebugConsole.filterElem = document.querySelector<HTMLInputElement>("#debugConsoleFilter");
        }

        if (DebugConsole.debugConsoleElem.checkVisibility()) {
            DebugConsole.debugConsoleElem.style.display = "none";
            sessionStorage.setItem('debugConsoleShown', 'false');
        }
        else {
            DebugConsole.debugConsoleElem.style.display = "block";
            sessionStorage.setItem('debugConsoleShown', 'true');
        }
    }

    public static appendDebugLog(message: string) {
        if (DebugConsole.debugConsoleElem && DebugConsole.debugConsoleElem.checkVisibility()) {
            const currentDt = new Date();
            let day = currentDt.getDate();
            let month = currentDt.getMonth() + 1;
            let year = currentDt.getFullYear();
            let hour = currentDt.getHours();
            let minute = currentDt.getMinutes();
            let second = currentDt.getSeconds();
            let millisecond = currentDt.getMilliseconds();
            const formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${second}:${millisecond}`;

            let shown = "block";
            if (DebugConsole.filterElem.value && !message.includes(DebugConsole.filterElem.value)) {
                shown = "none";
            }

            DebugConsole.debugConsoleElem.insertAdjacentHTML('beforeend', `<p class="debugLog" style="display: ${shown};">${formattedDate}: ${window.escapeHTML(message)}</p>`);
        }
    }

    public static filterDebugLog() {
        if (DebugConsole.debugConsoleElem && DebugConsole.debugConsoleElem.checkVisibility()) {
            const filterValue = document.querySelector<HTMLInputElement>("#debugConsoleFilter").value;

            document.querySelectorAll<HTMLElement>(".debugLog").forEach(el => {
                if (el.textContent.includes(filterValue)) {
                    el.style.display = "block";
                }
                else {
                    el.style.display = "none";
                }
            });
        }
    }

    public static clearDebugLog() {
        document.querySelectorAll(".debugLog").forEach(el => el.remove());
    }
}

self.DebugConsole = DebugConsole;

enum LogType {
    Information,
    Warn,
    Error
}

export default ascommon;
// for main thread this is window, for workers this is the WorkerGlobalScope
self.ascommon = ascommon;
self.logType = LogType;
